import React from 'react';

function Videos(props) {
    return (
        <div>
            videox
        </div>
    );
}

export default Videos;